import { INVOICE_SCOPE } from "@msys/textutils";
import { AvailableReplacementsModal } from "../documents/AvailableReplacementsModal.js";

interface Props {
  handleClose(): void;
}

export function InvoiceTextsAvailableReplacementsModal({ handleClose }: Props) {
  return (
    <AvailableReplacementsModal
      scope={INVOICE_SCOPE}
      handleClose={handleClose}
    />
  );
}
